export const communicationPreferenceKeys = {
	all: ['communicationPreferences'] as const,
	/** The signed-in customer's own. */
	mine: () => [...communicationPreferenceKeys.all, 'mine'] as const,
	/** A customer's, as seen by staff. Keyed by id so two customers cannot share a cache entry. */
	forUser: (userId: string) => [...communicationPreferenceKeys.all, 'user', userId] as const,
};
